import React from 'react';
import styled from 'styled-components';

const DateHeader = styled.p`
  font-weight: bold;
`

export default DateHeader;